import React from "react";
import "./tools.css";
import { motion } from "framer-motion/dist/framer-motion";

const tools = [
  {
    imgUrl:
      "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_640.png",
    title: "HTML",
    subtitle: "Lorem ipsum dolor sit amet, consectetur.",
  },
  {
    imgUrl:
      "https://blog.logrocket.com/wp-content/uploads/2021/02/CSS-new-features-2021.png",
    title: "CSS",
    subtitle: "Lorem ipsum dolor sit amet, consectetur.",
  },
  {
    imgUrl:
      "https://blog.logrocket.com/wp-content/uploads/2021/02/machine-learning-libraries-javascript.png",
    title: "AA Hospitality",
    subtitle: "Lorem ipsum dolor sit amet, consectetur.",
  },
  {
    imgUrl:
      "https://eventcartel.com/media/news/18f5a497-d336-4c8b-abba-29301d686ff2.png",
    title: "Outstanding Chef",
    subtitle: "Lorem ipsum dolor sit amet, consectetur.",
  },
];

const Tools = () => {
  const fadeLeft = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  return (
    <div className="tools">
      <div className="tools__left">
        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          Tools & Tools
        </motion.h1>

        <motion.div
          variants={fadeLeft}
          initial="hidden"
          animate="visible"
          transition={{ duration: 1 }}
          className="tool"
        >
          <div className="tool-column tool-first">
            <div className="tool-content">
              <img
                src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_640.png"
                alt="tool-img"
              />
              <div>
                <p className="tool-title">HTML</p>
                <p className="tool-title sub">
                  Lorem Ipsum Dolor Sit Amet, Consectetur.
                </p>
              </div>
            </div>
            <div className="tool-content">
              <img
                src="https://w7.pngwing.com/pngs/696/424/png-transparent-logo-css-css3-thumbnail.png"
                alt="tool-img"
              />
              <div>
                <p className="tool-title">CSS</p>
                <p className="tool-title sub">
                  Lorem Ipsum Dolor Sit Amet, Consectetur.
                </p>
              </div>
            </div>
          </div>

          <div className="tool-column tool-second">
            <div className="tool-content">
              <img
                src="https://pbs.twimg.com/profile_images/1512774369558372361/IegUPpg-_400x400.jpg"
                alt="tool-img"
              />
              <div>
                <p className="tool-title">Javascript</p>
                <p className="tool-title sub">
                  Lorem Ipsum Dolor Sit Amet, Consectetur.
                </p>
              </div>
            </div>
            <div className="tool-content">
              <img
                src="https://pbs.twimg.com/profile_images/1417534297037103104/-aGMDn-Z_400x400.jpg"
                alt="tool-img"
              />
              <div>
                <p className="tool-title">React Js</p>
                <p className="tool-title sub">
                  Lorem Ipsum Dolor Sit Amet, Consectetur.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="tools__right">
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          src="https://images.unsplash.com/photo-1579567761406-4684ee0c75b6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8dGVjaHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
          alt="tools-img"
        />
      </div>
    </div>
  );
};

export default Tools;
